module.exports = __webpack_public_path__ + "static/media/hoffe.da2bd0d7.JPG";